import { render } from "./HeaderMobile.component.vue?vue&type=template&id=318e8078"
import script from "./HeaderMobile.component.vue?vue&type=script&lang=js"
export * from "./HeaderMobile.component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__